/**
 * Abstract class for mailing services
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Matt <matt.anderson@opensoftdev.com>
 */

define(['assets/js/modules/View'], function(View) {
    return View.extend({
        options: {},
        zones: {},
        context: null,
        productSlug: null,

        initialize: function(options) {
            this.options = options.options;
            this.$el.attr({
                width: this.model.get('width'),
                height: this.model.get('height')
            });

            this.context = this.$el.get(0).getContext('2d');
        }
    });
});
